import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {pfosten, kappen} from '../../../../../assets/images/data';
import {updatePfostenTore,
       updateKappenTore,
       updateStepsTore} from '../../../../store/actions/tore';
import {Textfield} from '../../../../module/textField';
import scrollToElement from '../../../../module/scrollToElement';


const Step_5 = (props) => {
   let [iskappen, updateIsKappen] = useState('');
   let [pfosten_width, updatePfostenWidth] = useState('');


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      let pfostenWrapper = document.querySelectorAll('.pfostenWrapper');
      let kappenWrapper = document.querySelectorAll('.kappenWrapper img');

      const {
            iskappen,
            pfosten_width,
            kappe,
            ispfosten,
            kappe_index
         } = props.data[props.modell_index].pfosten[0];


      updateIsKappen(iskappen);
      updatePfostenWidth(pfosten_width);

      if (pfosten_width) scrollToElement(); //scroll to Next Button Container

      //pfosten
      if(ispfosten) {
         pfostenWrapper[0].classList.add('check');
      } else {
         pfostenWrapper[0].classList.remove('check');
      }

      //kappen
      for (let i = 0; i < kappenWrapper.length; i++) {
         kappenWrapper[i].classList.remove('check');
       }
      if(kappe && kappenWrapper[kappe_index]) {
         kappenWrapper[kappe_index].classList.add('check');
      }

      //update steps
      props.updateSteps(4);
      if (ispfosten || (pfosten_width && kappe))  props.updateSteps(5);

      //Weiter-Button aktivieren
      if (ispfosten || props.data[props.modell_index].allVisitedSteps || (pfosten_width && kappe)) {
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue();
      }

   }

   const selectPfosten = ev => {
      let pfostenObject = {
         ident_index: ev.currentTarget.getAttribute('index'),
         ident_name: ev.currentTarget.getAttribute('name'),
         value: ev.target.value
      }

      props.updatePfosten(pfostenObject);
      updateItems();
   }

   const updateKappen = ev => {
      let kappeObject = {
         titel: ev.currentTarget.getAttribute('titel'),
         index: ev.currentTarget.getAttribute('index')
      }
      props.updateKappen(kappeObject);
      updateItems();
   }

  const pfosten_option = [
      {titel: '60 x 60'},
      {titel: '80 x 80'},
      {titel: '100 x 100'},
      {titel: '120 x 120'},
      {titel: '140 x 140'},
      {titel: '160 x 160'}
  ];


   return (
           <div className="step_wrapper">

             <h2 className="step_header">Benötigen Sie Pfosten?</h2>
              <div className="step_icon_wrapper">
                  <div className="inner-pfosten-wrapper">
                        {pfosten.map((elem, index) => (
                           <div className="pfostenWrapper" onClick={selectPfosten} name='pforteselect' key={index} index={index} titel={elem.titel}>
                                 <p>{elem.titel}</p>
                           </div>
                        ))}
                  </div>
            </div>

            {iskappen ?
            <>
            <h2 className="step_header">Form der Pfosten</h2>
            <div className='kappen-wrapper'>
                  <Textfield
                     label="Bitte wählen"
                     select
                     type="text"
                     rowsMax={1}
                     value={pfosten_width}
                     onChange={selectPfosten}
                     array_options={pfosten_option}
                     name='pfostenwidth'
                  >
                  </Textfield>
                  <h2 className="step_header">Welche Kappen?</h2>
                  <div className="step_icon_wrapper">
                        <div className="inner-kappen-wrapper">
                              {kappen.map((elem, index) => (
                                 <div className="kappenWrapper" onClick={updateKappen} key={index} index={index} titel={elem.titel}>
                                       <img src={elem.img} alt={elem.titel}/>
                                       <p>{elem.titel}</p>
                                 </div>
                              ))}
                        </div>
                  </div>
            </div>
            </>: ''}
          </div>
   )
}

const mapStateToProps = state => {
    return {
      data: state.toreReducer.data,
      modell_index: state.toreReducer.modell_index
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updatePfosten: ev => dispatch(updatePfostenTore(ev)),
      updateKappen: ev => dispatch(updateKappenTore(ev)),
      updateSteps: ev => dispatch(updateStepsTore(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_5);
